// extracted by mini-css-extract-plugin
export default {"Avatar":"k1LWoLMHeYylGLzWFuVQ","AvatarUpload":"YwOBDydBjjfpL4XP8Uo6"};